<div class="ship-details-print-dialog ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>Print Shipment Details</h2>
        <mat-dialog-actions></mat-dialog-actions>
        <button class="btn close-button-small" mat-dialog-close>
            <i class="material-icons">close</i>
        </button>
    </div>
    <mat-dialog-content>
        <div id="print-ship-details" [innerHtml]="htmlContent"></div>
    </mat-dialog-content>
</div>
